import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Box } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { useSendMail } from '../hooks/useSendMail';

const schema = z.object({ mailboxId: z.string().min(1), to: z.string().min(1), subject: z.string().optional(), html: z.string().optional() });

export default function ComposeDialog({ open, onClose, mailboxes }) {
  const { control, register, handleSubmit } = useForm({ resolver: zodResolver(schema) });
  const send = useSendMail();
  const onSubmit = async (data) => {
    const payload = { mailboxId: data.mailboxId, from: undefined, to: data.to.split(/[;,]+/).map(s=>s.trim()), subject: data.subject, html: data.html, saveToSent: true };
    await send.mutateAsync(payload);
    if (onClose) onClose();
  };
  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Compose</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
          <TextField select label="Mailbox" fullWidth {...register('mailboxId')}>
            {(mailboxes || []).map(m => <MenuItem key={m.id} value={m.id}>{m.displayName || m.email}</MenuItem>)}
          </TextField>
          <TextField label="To" fullWidth {...register('to')} placeholder="comma separated" />
        </Box>
        <TextField label="Subject" fullWidth sx={{ mt: 1 }} {...register('subject')} />
        <Controller name="html" control={control} defaultValue="" render={({ field }) => (
          <Box sx={{ mt: 1 }}>
            <ReactQuill value={field.value} onChange={field.onChange} />
          </Box>
        )} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit(onSubmit)}>Send</Button>
      </DialogActions>
    </Dialog>
  );
}
